module.exports = "<div class=\"js-dom-element\">\n\t<div class=\"js-camera-element\">\n\t\t<content></content>\n\t</div>\n</div>";
